module.exports = __webpack_public_path__ + "img/bank-assets-blue.9744fe1c.svg";